/*eslint @typescript-eslint/no-empty-function: "off"*/

import React, { useEffect, memo, useCallback } from 'react';
import { ToastMessage, ToastWrapper, ToastCloseIcon } from './styles';
import { NotificationType } from 'store/notifications/NotificationsSlice';

interface IComponentProps {
  id: string;
  type: NotificationType;
  message: string;
  autoClose?: boolean;
  timeToHide?: number;
  onClose?: (id: string) => void;
}

const Toast: React.FC<IComponentProps> = ({
  id,
  type,
  message,
  timeToHide = 3000,
  autoClose = true,
  onClose = () => () => {},
}: IComponentProps) => {
  useEffect(() => {
    let timer: number | undefined;
    if (autoClose) {
      timer = window.setTimeout(() => {
        onClose(id);
      }, timeToHide);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [id, autoClose, timeToHide, onClose]);

  const handleCloseCallback = useCallback(
    (id: string) => (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      onClose(id);
    },
    [onClose]
  );

  return (
    <ToastWrapper type={type}>
      <ToastMessage>{message}</ToastMessage>
      {!autoClose && (
        <ToastCloseIcon type="x" onClick={handleCloseCallback(id)} />
      )}
    </ToastWrapper>
  );
};

export default memo(Toast);
